import { admin } from '../../api/client.js';
import { useApi } from '../../hooks/useApi.js';
import { Badge } from '../../components/Badge.js';
import { LoadingSpinner } from '../../components/LoadingSpinner.js';
import { ErrorMessage } from '../../components/ErrorMessage.js';
import type { AdminUser } from '../../types/index.js';

const ROLE_LABELS: Record<string, string> = {
  platform_admin: 'Admin',
  tenant_admin: 'Server Admin',
  tenant_member: 'Member',
};

export function AdminUsersPage() {
  const { data, loading, error, refetch } = useApi<{ users: AdminUser[] }>(
    () => admin.users(),
    [],
  );

  const userList = data?.users ?? [];

  if (loading) return <LoadingSpinner text="Loading users..." />;
  if (error) return <ErrorMessage message={error} onRetry={() => void refetch()} />;

  return (
    <>
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontFamily: 'var(--fd)', fontSize: 18, fontWeight: 700, letterSpacing: '-0.02em', marginBottom: 4 }}>All Users</h2>
        <p style={{ fontSize: 13, color: 'var(--t3)' }}>Everyone who has logged into the platform</p>
      </div>

      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Username</th>
              <th>Discord ID</th>
              <th>Role</th>
              <th>Whitelisted</th>
              <th>2FA</th>
              <th>Joined</th>
            </tr>
          </thead>
          <tbody>
            {userList.map((u) => (
              <tr key={u.id}>
                <td style={{ color: 'var(--t1)', fontWeight: 500 }}>{u.discordUsername}</td>
                <td style={{ fontFamily: 'monospace', fontSize: 12, color: 'var(--t3)' }}>{u.discordId}</td>
                <td>
                  <Badge
                    status={u.role === 'platform_admin' ? 'active' : 'joined'}
                    label={ROLE_LABELS[u.role] ?? u.role}
                  />
                </td>
                <td>
                  <Badge
                    status={u.whitelisted ? 'active' : 'expired'}
                    label={u.whitelisted ? 'Approved' : 'Pending'}
                  />
                </td>
                <td>
                  <Badge
                    status={u.totpEnabled === true ? 'active' : 'expired'}
                    label={u.totpEnabled === true ? 'Enabled' : 'Off'}
                  />
                </td>
                <td style={{ color: 'var(--t3)', fontSize: 12 }}>
                  {new Date(u.createdAt).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
